// @ts-nocheck
import { takeLatest, all, call, put } from 'redux-saga/effects';
import * as types from 'redux/actions/management_dashboard';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import getQueryParams from 'utils/getQueryParams';
import { Logger } from 'utils/logger';

function* getDashboardReports(action) {
  try {
    const token = localStorage.getItem('token');
    const { payload } = action;
    const query = getQueryParams(payload);

    const [reports, preference] = yield all([
      call(services.fetchGetApi, `${API_URI}/admin-dashboard/?${query}`, token),
      call(services.fetchGetApi, `${API_URI}/dashboard-layout/`, token),
    ]);
    yield put({
      type: types.GET_DASHBOARD_REPORTS_SUCCESS,
      payload: reports,
    });
    yield put({
      type: types.SET_USER_PREFERENCE,
      payload: preference,
    });
  } catch (err) {
    Logger.error({
      message: 'Error getting dashboard reports',
      data: err,
    });
    yield put({
      type: types.GET_DASHBOARD_REPORTS_FAILURE,
    });
  }
}

function* addUserPreference(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  yield call(
    services.fetchPostApi,
    `${API_URI}/dashboard-layout/`,
    payload,
    token,
  );
}

function* updateUserPreference(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  yield call(
    services.fetchPutApi,
    `${API_URI}/dashboard-layout/${payload.id}/`,
    payload,
    token,
  );
}

function* managementDashboardWatcher() {
  yield takeLatest(types.GET_DASHBOARD_REPORTS_REQUEST, getDashboardReports);
  yield takeLatest(types.ADD_USER_PREFERENCE_REQUEST, addUserPreference);
  yield takeLatest(types.UPDATE_USER_PREFERENCE_REQUEST, updateUserPreference);
}

export default managementDashboardWatcher;
